import React, { useCallback, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

export const App = (props) => {
  const imgRef = useRef();

  return (
    <TransformWrapper
      initialScale={1}
      maxScale={3}
      limitToBounds={false}
      centerZoomedOut={true}
      centerOnInit={true}
      disablePadding={true}
    >
    {({ centerView, ...rest }) => (
      <TransformComponent>
        <img ref={imgRef} src={props.src} onLoad={() => { centerView(1) }}/>
      </TransformComponent>
    )}
    </TransformWrapper>
  );
};

export default App;
